import axios from 'axios'
import { URIS, loadHeaders } from '../Uris'
import { errorMessage } from '../helpers'

export const FETCH_INSTRUCTORS = 'FETCH_INSTRUCTORS'
export const FETCH_INSTRUCTORS_SUCCESS = 'FETCH_INSTRUCTORS_SUCCESS'
export const FETCH_INSTRUCTORS_FAILURE = 'FETCH_INSTRUCTORS_FAILURE'
export const SAVE_INSTRUCTORS_SUCCESS = 'SAVE_INSTRUCTORS_SUCCESS'
export const SAVE_INSTRUCTORS_FAILURE = 'SAVE_INSTRUCTORS_FAILURE'
export const INSTRUCTORS_AJAX_CALL = 'INSTRUCTORS_AJAX_CALL'
export const INSTRUCTORS_CLEAR_AJAX_CALL = 'INSTRUCTORS_CLEAR_AJAX_CALL'
export const DELETE_INSTRUCTORS_SUCCESS = 'DELETE_INSTRUCTORS_SUCCESS'
export const DELETE_INSTRUCTORS_FAILURE = 'DELETE_INSTRUCTORS_FAILURE'

export function loadInstructors() {
  return (dispatch) => {
    dispatch(fetchInstructors())
    axios({
      method: 'GET',
      url: URIS.instructors,
      headers: loadHeaders()
    })
      .then((res) => {
        dispatch(fetchInstructorsSuccess(res.data))
      })
      .catch((error) => {
        dispatch(fetchInstructorsFailure(errorMessage(error)))
      })
  }
}

function fetchInstructors() {
  return {
    type: FETCH_INSTRUCTORS
  }
}

function fetchInstructorsSuccess(payload) {
  return {
    type: FETCH_INSTRUCTORS_SUCCESS,
    payload
  }
}

function fetchInstructorsFailure(payload) {
  return {
    type: FETCH_INSTRUCTORS_FAILURE,
    payload
  }
}

export function saveInstructors(payload) {
  return (dispatch) => {
    dispatch(loadingAjaxCall())
    axios({
      method: 'POST',
      url: URIS.instructors,
      headers: loadHeaders(),
      data: payload
    })
      .then((res) => {
        dispatch(saveInstructorsSuccess(res.data))
      })
      .catch((error) => {
        dispatch(saveInstructorsFailure(errorMessage(error)))
      })
  }
}

function saveInstructorsSuccess(payload) {
  return {
    type: SAVE_INSTRUCTORS_SUCCESS,
    payload
  }
}

function saveInstructorsFailure(payload) {
  return {
    type: SAVE_INSTRUCTORS_FAILURE,
    payload
  }
}

export function deleteInstructors(payload) {
  return (dispatch) => {
    dispatch(loadingAjaxCall())
    axios({
      method: 'DELETE',
      url: URIS.instructors,
      headers: loadHeaders(),
      data: payload
    })
      .then((res) => {
        dispatch(deleteInstructorsSuccess(res.data.data))
      })
      .catch((error) => {
        dispatch(deleteInstructorsFailure(errorMessage(error)))
      })
  }
}

function deleteInstructorsSuccess(payload) {
  return {
    type: DELETE_INSTRUCTORS_SUCCESS,
    payload
  }
}

export function deleteInstructorsFailure(payload) {
  return {
    type: DELETE_INSTRUCTORS_FAILURE,
    payload
  }
}

function loadingAjaxCall() {
  return {
    type: INSTRUCTORS_AJAX_CALL
  }
}

export function clearAjaxCall(payload) {
  return {
    type: INSTRUCTORS_CLEAR_AJAX_CALL
  }
}



// WEBPACK FOOTER //
// ./src/actions/Instructors.js